import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useMutation } from '@apollo/react-hooks';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Form from 'components/form';
import Input from 'components/form/Input';
import Button from 'components/common/Button';
import { updateUser } from 'reducers/user';
import { UPDATE_USER } from 'graphql/Home';
import useSnack  from 'hooks/useSnack';
import useStyles from '../styles';
import ChangePasswordForm from './ChangePasswordForm';
import FileUpload from "../helperComponents/FileUpload";

const FormItem = Form.FormItem;

const AccountDetails = ({ form: { getFieldDecorator, validateFields } }) => {
  const dispatch = useDispatch();
  const [mutate] = useMutation(UPDATE_USER);
  const snack = useSnack();
  const user = useSelector((u) => u.user.user);
  const classes = useStyles();

  const onSubmit = () => {
    return validateFields().then((values) =>
      mutate({
        variables: {
          sub: user.sub,
          data: values,
        },
      })
        .then(() =>
          dispatch(updateUser({ email: values.user_email } )),
        )
        .then(() => snack.success('Account updated'))
        .catch((e) => snack.error(e.message)),
    );
  };

  return (
    <React.Fragment>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Grid container spacing={4} justify="space-between" alignItems="center">
            <Grid item md={6}>
              <Typography variant="h5" className={classes.header}>
                Account Details
              </Typography>
              <Input
                fullWidth
                label="User name"
                value={user.username}
                disabled
                hint="Username cannot be changed"
              />
              <Form>
                <FormItem>
                  {getFieldDecorator('user_email', {
                    initialValue: user.email,
                    rules: [
                      {
                        required: true,
                        type: 'email',
                      },
                    ],
                  })(
                    <Input
                      fullWidth
                      label="Email address"
                      hint="This email will be used for all client communications"
                    />,
                  )}
                </FormItem>
              </Form>
            </Grid>
            <Grid item md={6} >
              <FileUpload sub={user.sub} user={user} />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent className={classes.footer}>
          <Button variant="contained" color="primary" onClick={onSubmit}>
            Save
          </Button>
        </CardContent>
      </Card>
      <ChangePasswordForm />
    </React.Fragment>
  );
};

export default Form.create()(AccountDetails);
